var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8327 6.46407V7.00074C12.832 8.25865 12.4246 9.48263 11.6715 10.4901C10.9183 11.4976 9.8596 12.2347 8.65331 12.5913C7.44702 12.948 6.15775 12.9052 4.97779 12.4692C3.79783 12.0333 2.7904 11.2276 2.10574 10.1724C1.42109 9.11709 1.09589 7.86877 1.17866 6.61359C1.26143 5.3584 1.74772 4.16359 2.56501 3.20736C3.3823 2.25113 4.48681 1.58471 5.71379 1.30749C6.94078 1.03027 8.22451 1.1571 9.37352 1.66907",
    stroke: "#025F4C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 2.33203L7 8.1712L5.25 6.4212",
    stroke: "#025F4C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneCheckIcon);
export default __webpack_public_path__ + "static/media/doneCheckIcon.962c8298f8c049e29b00ca42624b780d.svg";
export { ForwardRef as ReactComponent };